export const mapPerson = (person): Content.Person => {
	if (!person) {
		return null;
	}

	return {
		fullName: person.properties?.fullName ?? null,
		workTitle: person.properties?.workTitle ?? null,
		email: person.properties?.email ?? null,
		bio: person.properties?.bio ?? null,
	};
};

export const mapFirstPerson = (persons: { person }[]): Content.Person => {
	if (!persons) {
		return null;
	}

	return mapPerson(persons.find((x) => x !== undefined));
};

export const mapPersons = (persons: { person }[]): Content.Person[] => {
	if (!persons) {
		return null;
	}

	return persons.map((person) => {
		return mapPerson(person);
	});
};
